import CleaningEquipment from './Constructor'

export default CleaningEquipment
export { CleaningEquipment }
